module.exports = __webpack_public_path__ + "static/img/title_icon.7b01430c.svg";